import { SVGProps } from 'react';

/**
 * IDA wordmark. Uses currentColor for the letterforms so the surrounding
 * Tailwind text-* class drives contrast — pass `text-text-main` on light
 * surfaces and `text-white` on dark surfaces. The accent dot is fixed
 * brand orange (#e95339) and reads well on both.
 */
export default function Logo({
  title = 'IDA',
  ...props
}: SVGProps<SVGSVGElement> & { title?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470.8 210.4"
      role="img"
      aria-label={title}
      {...props}
    >
      <title>{title}</title>
      <g fill="currentColor">
        <path d="M10,199.4V7.1h36.3v192.2H10Z" />
        <path d="M71.5,199.4v-31.9h25.3V39h-25.3V7.1h79.1c25.8,0,45.5,6.5,58.9,19.6,13.5,13.1,20.2,32.5,20.2,58.4v36.3c0,25.8-6.7,45.3-20.2,58.4-13.5,13.1-33.1,19.6-58.9,19.6h-79.1ZM133,166.4h18.1c14.6,0,25.4-3.8,32.1-11.5,6.8-7.7,10.2-18.5,10.2-32.4v-38.4c0-14.1-3.4-24.9-10.2-32.5-6.8-7.6-17.5-11.4-32.1-11.4h-18.1v126.3Z" />
        <path d="M374,123.6l19.9,75.8h-37.3l-10.4-42.3h-68.7l-10.4,42.3h-37.3L280.2,7.1h63.2l30.6,116.4M286,123.6h51.6l-23.3-93.6h-4.9l-23.3,93.6Z" />
      </g>
      <path
        fill="#e95339"
        d="M434.8,203.2c-7.3,0-13.5-2.4-18.5-7.3-5-4.8-7.6-11.1-7.6-18.8s2.5-14,7.6-18.8c5-4.8,11.2-7.3,18.5-7.3s13.7,2.4,18.7,7.3c4.9,4.9,7.4,11.1,7.4,18.8s-2.5,14-7.4,18.8c-4.9,4.8-11.2,7.3-18.7,7.3Z"
      />
    </svg>
  );
}
